import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";

@Component({
  selector: 'app-survey-recommendation',
  templateUrl: './survey-recommendation.component.html',
  styleUrl: './survey-recommendation.component.scss',
  standalone: false
})
export class SurveyRecommendationComponent implements OnInit, OnDestroy {
  @Input() questionDetails: any;
  @Input() surveyData: any
  @Output() answerSelectedEvent = new EventEmitter<any>();

  ngOnInit(): void { 
  }

  ngOnDestroy(): void {
  }
}
